try{self['workbox:sw:7.3.0']&&_()}catch(e){}// eslint-disable-line